export default "__VITE_PUBLIC_ASSET__8bca0078__"